import { render, staticRenderFns } from "./index-tc.vue?vue&type=template&id=d98e345c&scoped=true"
import script from "./index-tc.vue?vue&type=script&lang=js"
export * from "./index-tc.vue?vue&type=script&lang=js"
import style0 from "./index-tc.vue?vue&type=style&index=0&id=d98e345c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98e345c",
  null
  
)

export default component.exports